import './App.css';
import React from 'react';
import { Routes, Route } from 'react-router-dom'; 
import NavBar from './components/NavBar'; 
import HomePage from './pages/HomePage'; 
import About from './pages/About'; 
import Contact from './pages/Contact';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        {/* <img src={logo} className="App-logo" alt="logo" /> */}
        {/* <HomePage/> */}
        {/* <p>
          DLZ Ventures LLC <code>src/App.js</code> .
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a> */}
        <NavBar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </header>
    </div>
  );
}

export default App;
